module.exports = {
    agent: {
        // From a content setting.
        redirectToAgentUrlText:
            '<p>Now you can purchase ingredients from the&nbsp;<a href="{RedirectToAgentUrl}" target="_parent" style="color: #E95716;">menu tab</a></p>',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/agent.js